import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import { Communicators } from 'presentation/components/Message';
import styles from 'presentation/components/styles/Message.css';
let cx = classnames.bind(styles);

export default function Error(props) {
  const errorPropTypes = {
    sender: PropTypes.string.isRequired,
  };
  PropTypes.checkPropTypes(errorPropTypes, props, 'prop', 'Error');

  let classes = cx('message_error', {
    message_error_customer: props.sender === Communicators.CUSTOMER,
  });
  return <div className={classes}>Message failed to send.</div>;
}
